import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AcedTextArea from "../../../components/essentials/input/text-area/AcedTextArea";

const JobDescription = () => {
	const { t } = useTranslation();
	const { control } = useFormContext();

	return (
		<AcedTextArea
			label={t("createJob.descriptionLabel", "Job Description")}
			control={control}
			name="description"
			// placeholder={t("createJob.descriptionPlaceholder", "Descrtiption")}
			rules={{ required: "This field is required" }}
		/>
	);
};

export default JobDescription;
